import React from "react";
import Loader from 'react-loader-spinner'
import { getBoundingClientRect } from "../../utils/functions";
import HttpService from '../../utils/Http.services';
import { checkTextTranslation, checkTranslation, getObject, imageAddress, translate } from "../../utils/useful";
import FixedView from "../FixedView";


class GlobalUserMultiInput extends React.Component {

    state = {
        isOpen: false,
        data: [],
        title: '',
        tempData: [],
        options: [],
        isLoading: false,
        choosen: [],
        lastNewId: 0

    }

    toggleOpen = (open) => {
        let openState = open != null ? open : !this.state.isOpen

        if (openState) {
            this.fixedView.showView()
        } else {
            this.fixedView.hideView()
        }

        this.setState({ isOpen: openState, data: this.props.data })

    }

    // toggleOpen = (open) => {
    //     // console.log("HERE")
    //     let openState = open != null ? open : !this.state.isOpen

    //     if (openState) {
    //         document.addEventListener('mousedown', this.closeBox);
    //         window.addEventListener('scroll', this.getPosition, true);
    //         this.getPosition()

    //     } else {
    //         document.removeEventListener('mousedown', this.closeBox);
    //         window.removeEventListener('scroll', this.getPosition);

    //     }
    //     // this.refs.icon.classList.toggle("rotate-180")

    //     this.setState({ isOpen: openState, data: this.props.data })

    // }

    // openBox = () => {

    //     if (!this.state.isOpen) {
    //         document.addEventListener('mousedown', this.closeBox);
    //     }
    //     // this.refs.icon.classList.toggle("rotate-180")

    //     this.setState({ isOpen: true, data: this.props.data })

    // }

    closeBox = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
            this.setState({ isOpen: false, data: this.props.data })
            document.removeEventListener('mousedown', this.closeBox);
            window.removeEventListener('scroll', this.getPosition);

            // this.refs.icon.classList.toggle("rotate-180")

        }
    }


    getPosition = () => {
        // console.log("getPosition")
        let rect = getBoundingClientRect(this.wrapperRef)
        this.setState({ top: rect.top + 35, left: rect.left - 10 })
    }


    changeItem = (prop, selected, dontChangeValue) => {

        // console.log("CHANGE")
        var choosen = this.state.choosen
        this.setState({ title: '' }, () => {
            if (this.refs.input)
                this.refs.input.focus()
        })


        if (selected) {
            for (let i = 0; i < choosen.length; i++) {

                if (choosen[i].value == prop.value) {
                    choosen.splice(i, 1)
                }
            }
        } else {
            choosen.push(prop)
        }

        this.setState({ choosen }, () => {
            if (!dontChangeValue) this.changeValue()
        })

        setTimeout(() => {
            this.toggleOpen(true)
        }, 1);

        // setTimeout(
        //     function () {
        //         this.toggleOpen()
        //     }
        //         .bind(this),
        //     1
        // );


        if (this.state.tempData.length > 0)
            this.setState({ options: this.state.tempData })

        // this.changeFilter(prop.value)

    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    componentDidMount() {
        this.mounted = true
        // console.log(this.props.data)
        this.init()

    }

    componentDidUpdate(prevProps) {
        // console.log(this.props.data)

        if (prevProps.data != this.props.data && this.mounted) {
            this.init()
        }
    }

    componentWillUnmount() {
        this.mounted = false
    }


    init() {
        if (this.props.header.information) {
            if (this.props.header.information.type == "local") {

                let options = []
                let choosen = []

                if (this.props.header.information.items && this.props.header.information.items.length > 0) {
                    options = this.props.header.information.items
                }

                if (this.props.title && Array.isArray(this.props.title)) {
                    this.props.title.forEach(element => {
                        choosen.push({ title: element, value: element })
                    });
                }
                // console.log(this.props.title)
                this.setState({ options, choosen })
            } else if (this.props.header.information.type == "api") {
                // console.log(this.props.title)
                this.fetch()
            }
        }
    }


    fetch() {
        this.setState({ isLoading: true })
        let address = this.props.header.information.address
        let filter = typeof this.props.header.information.filter == "string" ? JSON.parse(this.props.header.information.filter) : this.props.header.information.filter
        // console.log('filter', filter)
        if (!filter) {
            filter = {}
        }
        for (const [key, value] of Object.entries(filter)) {
            if (/\{\{(.*?)\}\}/.test(value)) {
                if (this.props.variables) {
                    filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }
        // console.log(filter)

        HttpService.request(address ?? 'searchUser', filter, (fetchResult, fetchError) => {
            // console.log(fetchError)
            if (fetchError) { return }

            // console.log(fetchResult)
            // fetch(address, {
            //     method: 'POST',
            //     body: JSON.stringify(filter),
            //     headers: headers
            // }).then(response => response.json()).then(data => {
            // console.log(data)
            // if (data.status == 200 && this.mounted) {
            var newData = []
            // fetchResult.info.forEach(element => {

            //     var newTitle = this.spliter(element, this.props.header.information.fields.title)
            //     var newValue = this.spliter(element, this.props.header.information.fields.value)

            //     newData.push({ value: newValue, title: newTitle })
            //     // var newTitle = this.spliter(element, this.props.header.information.fields.title)
            //     // var newValue = this.spliter(element, this.props.header.information.fields.value)

            //     // newData.push({ value: newValue, title: newTitle })
            // });


            fetchResult.info.forEach(element => {

                let newTitle = this.spliter(element, this.props.header.information.fields.title)
                let newValue = this.spliter(element, this.props.header.information.fields.value)
                let newImage
                let newDescription
                if (this.props.header.information.fields.image) {
                    newImage = this.spliter(element, this.props.header.information.fields.image)
                }
                if (this.props.header.information.fields.description) {
                    newDescription = this.spliter(element, this.props.header.information.fields.description)
                }
                let parent = this.spliter(element, this.props.header.information.fields.parent)

                // if (parent && parent != '') {
                newData.push({ value: newValue, title: newTitle, image: newImage, description: newDescription, parent: (typeof parent == 'object' ? parent?._id : parent) })
                // } else {
                //     newParents.push({ value: newValue, title: newTitle,image:newImage, parent: (typeof parent == 'object' ? parent._id : parent) })
                // }

            });



            let helperKey = this.props.header.information.helperKey
            if (Array.isArray(this.props.data)) {
                let choosen = []
                this.props.data.forEach(oneTitle => {
                    let _id

                    if (helperKey) {
                        _id = typeof oneTitle == 'object' ? getObject(oneTitle, helperKey) : oneTitle
                    } else {
                        _id = typeof oneTitle == 'object' ? oneTitle._id : oneTitle
                    }
                    let oneTitleId = _id
                    newData.forEach(oneNewData => {

                        if (oneNewData.value == oneTitleId) {
                            choosen.push({ title: oneNewData.title, value: oneTitleId })
                        }
                    });

                })
                this.setState({ choosen })

            }

            this.setState({
                options: newData,
                isLoading: false
            })
        })

        // }).catch(error => this.setState({ error, isLoading: false }));
    }


    spliter(source, string) {
        if (string) {
            var stringArray = string.split('.')
            var finalString = source
            stringArray.forEach(element => {
                finalString = finalString[element]
            });
            return finalString
        } else {
            return null
        }
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] == condition) {
                return true
            }
        }
        return false
    }


    search = async (value) => {

        // console.log(value)
        this.setState({ title: value })
        if (!this.state.isOpen) {
            this.toggleOpen()
        }

        if (value == "") {
            await this.setState({ options: this.state.tempData })
            await this.setState({ tempData: [] })
        } else {
            if (this.state.tempData.length == 0) {
                await this.setState({ tempData: this.state.options })
            }
            var values = []
            // var values = this.props.data.filter((e) => e.title === value)
            // console.log(this.state.tempData)
            this.state.tempData.forEach(element => {
                if (String(element.title).toLowerCase().includes(String(value).toLowerCase())) {
                    values.push(element)
                }
            })
            // console.log(values)

            this.setState({ options: values })

            // }
        }
    }


    removeItem(index) {
        let choosen = [...this.state.choosen]
        choosen.splice(index, 1)
        this.setState({ choosen }, () => {
            this.changeValue()
        })
    }


    addTag() {
        let tempData = [...this.state.tempData]
        let choosen = [...this.state.choosen]

        let item = { title: this.state.title, value: this.state.title }
        tempData.push(item)
        // choosen.push(item)
        this.setState({ tempData }, () => {
            this.changeItem(item, false)
        })
        this.refs.input.focus()
    }

    changeValue() {
        let choosen = []
        this.state.choosen.forEach(element => {
            choosen.push((typeof element.value == 'object' ? element.value._id : element.value))
            // choosen.push((element.value))

        });
        // console.log(choosen)
        this.props.changeValue(this.props.header.key, choosen, this.props.extra)
    }


    render() {

        return (
            <div className='mt-0 w-100 h-100 flexc ' style={{ position: 'relative' }}  >
                <div ref={ref => this.setWrapperRef(ref)} className='mt-0 w-100 h-100 flexc' style={{ position: 'relative' }} onClick={() => this.toggleOpen(true)} >

                    <div ref={ref => this.setWrapperRef(ref)} className="w-100" >
                        <div className="flexcb w-100 h-100">
                            <div className="ref" ref={el => this.currentNode = el} onClick={() => { if (!this.props.data || typeof this.props.data != 'object') { this.toggleOpen(true) } }} style={{ flex: 1, cursor: 'pointer' }}>

                                {/* <span style={{ opacity: 0 }}>0</span> */}

                                {this.props.header.information.placeholder && !this.state.choosen?.length && (
                                    <div className="h-100 w-100 flexc" style={{ position: 'absolute', top: 0 }}>
                                        <label className={' mrd-1 mld-1 placeholder w-100 '}>{checkTextTranslation(this.props.header.information.placeholder)}</label>
                                    </div>
                                )}

                                <div className="wrapper w-100"  >
                                    <div style={{ flexWrap: 'wrap', borderRadius: 4, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                        {this.state.choosen.map((prop, index) => {
                                            // console.log(prop)
                                            return (
                                                <div key={prop.value} className="" style={{ display: 'inline-flex', alignItems: 'center', paddingTop: 2, paddingBottom: 2 }}>
                                                    <div className="flexcc" key={index} style={{ padding: 5, backgroundColor: '#78b2d020', borderRadius: 4, marginRight: 2, marginLeft: 2, flexWrap: 'nowrap', paddingLeft: 7, paddingRight: 7 }}>
                                                        <div className="flexcc">
                                                            <img src={imageAddress(prop?.image, 'profile', 'small')} width="26px" style={{ border: '1px solid #eee', borderRadius: 50, height: 26, objectFit: 'cover' }} />
                                                        </div>
                                                        <p style={{ whiteSpace: 'nowrap', marginBottom: 0, marginRight: 2, marginLeft: 2, fontSize: 12, marginTop: 0, color: '#202020' }}>{prop.title}</p>
                                                        <img src="/assets/icons/close.svg" onClick={(e) => { this.removeItem(index); e.stopPropagation() }} style={{ padding: 2, paddingLeft: 0, color: '#78b2d0', width: 18, height: 18 }} />
                                                    </div>

                                                    {/* {index != this.state.choosen.length - 1 && (
                                                        <i className="fa fa-arrow-right" style={{ color: '#78b2d0' }}></i>
                                                    )} */}

                                                </div>
                                            )
                                        })}

                                        {/* <div className={"position-relative mt-0 mld-1 "}> */}
                                        {/* {!this.state.isFinal && (
                                             <input ref={'input'} value={this.state.title} onFocus={() => { this.toggleOpen() }} onInput={event => this.search(event.target.value)} onChange={e => { this.props.changeValue(this.props.headerkey, e.target.value) }} className='nofocus mediumiransansfont' style={{ backgroundColor: 'transparent', minWidth: 100, width: this.state.title.length * 9, border: 'none' }} />
                                        )} */}


                                        {this.state.isLoading && (
                                            <div style={{ position: 'absolute', top: 0, right: 5 }}>
                                                <Loader
                                                    type="Oval"
                                                    color="rgba(0,122,255,1)"
                                                    height="20"
                                                    width="20"
                                                />
                                            </div>
                                        )}
                                        {/* </div> */}
                                        {this.state.isFinal && (<i className="fa fa-check-circle mld-1" style={{ color: '#78b2d0', fontSize: 20 }}></i>)}

                                    </div>

                                    <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={0} bottomOffset={0} zIndex={5} xOffset={0} rightAlign={false} maxWidth={300}>

                                        <div className="text-start" ref={el => this.listView = el} style={{ display: 'flex', zIndex: 5, maxHeight: 250, maxWidth: 300, minWidth: 250 }}>
                                            <div className={'search-drop-down '} style={{ paddingBottom: 20, display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffff', borderRadius: 8, maxHeight: this.state.maxHeight, overflow: 'auto', boxShadow: '0px 0px 30px rgba(0,0,0,0.1)', border: '1px solid #eee' }}>
                                                {this.props.header.information.isSearchable && (
                                                    <div className="bg-white py-1 px-1 w-100" style={{ position: 'sticky', top: 0, zIndex: 1, }}>
                                                        <input className="w-100" value={this.state.search} onChange={event => this.search(event.target.value)} placeholder={translate("useful.searchPlaceholder")} style={{ fontSize: 14, padding: '8px 10px', margin: 0, backgroundColor: '#fff', borderRadius: 4, border: '#e0e2e6 solid 1px', marginTop: 0, }} />
                                                    </div>
                                                )}



                                                {/* {this.state.options.length != 0 && (
                                                    <div className="mt-2" onClick={() => this.changeItem({ value: '' })} style={{ cursor: 'pointer', backgroundColor: 'transparent', opacity: 0.5, padding: '5px 20px' }}>
                                                        <p style={{ margin: 0, color: '#456', fontSize: 13 }}>{checkTranslation(this.props.header?.information?.defaultPlaceholder ?? "{{lang}}useful.choosePlaceholder")}</p>
                                                    </div>
                                                )} */}

                                                {/* {this.state.parents?.map((prop, index) => {
                                    let selectableParent = this.props.header.information?.selectableParent
                                    let selected = false
                                    return (
                                        <div key={index}>
                                            {(!this.state.search || this.state.search == '') && (
                                                <div onClick={() => { if (selectableParent) this.changeItem(prop, selected) }} style={{ padding: '10px 20px', borderBottom: '1px solid #eee', marginBottom: 5, cursor: selectableParent ? 'pointer' : '' }}>
                                                    <p style={{ margin: 0, color: '#789', fontSize: 13 }}>{prop.title}</p>
                                                </div>
                                            )} */}
                                                {this.state.options?.map((cprop, cindex) => {
                                                    // let cselected = false

                                                    let selected = false
                                                    for (var i = 0; i < this.state.choosen.length; i++) {

                                                        if (cprop.value == this.state.choosen[i].value)
                                                            selected = true
                                                    }

                                                    // if (cprop.parent == prop.value) {
                                                    return (
                                                        <div className="">
                                                            <div className="flexc " key={cindex} onClick={() => this.changeItem(cprop, selected)} style={{ cursor: 'pointer', backgroundColor: selected ? '#f2f2f2' : '#fff', padding: '5px 20px' }}>
                                                                {this.props.header.information?.fields?.image && (
                                                                    <div className="flexcc">
                                                                        <img className="mrd-3" src={imageAddress(cprop.image, 'profile', 'small')} width="24px" height="24px" alt="" style={{ borderRadius: 40, objectFit: 'cover' }} />
                                                                    </div>
                                                                )}
                                                                <div className="d-flex flex-column justify-content-center">
                                                                    <p className="text-semibold" style={{ margin: 0, color: '#000', fontSize: 13 }}>{cprop.title}</p>
                                                                    <p style={{ margin: 0, color: '#789', fontSize: 12, lineHeight: 1.2 }}>@{cprop.description}</p>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                    // }
                                                })}
                                                {/* </div> */}
                                                {/* )
                                                 })} */}

                                                {this.state.options.length == 0 && (
                                                    <div className="px-2 pt-3">
                                                        <p style={{ textAlign: 'center', margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>{translate("useful.foundNothing")}</p>
                                                        {/* {this.props.header.information.tag && this.state.title != '' && (<p onClick={() => this.addTag()} style={{ textAlign: 'center', margin: 0, color: '#007aff', fontSize: 13, marginTop: 5, marginBottom: 5, cursor: 'pointer' }}>+ ADD THIS</p>)} */}

                                                    </div>
                                                )}

                                            </div>
                                        </div>

                                    </FixedView>

                                </div>

                            </div>
                        </div>
                    </div>

                </div>

            </div>
        );
    }
}


export default GlobalUserMultiInput;
